import type { LeaderboardParams } from '@/lib/api/rewards-leaderboard/client';
import type { LeaderboardSegment } from '@/lib/api/rewards-leaderboard/models';

/**
 * Shell shared by the home column's cards (Figma 15001:34504): 350 wide, 20/24 padding.
 * The light theme's card and page are both white, so the shadow is what outlines the card.
 */
export const SIDEBAR_CARD_CLASS =
  'relative flex flex-1 flex-col overflow-hidden rounded-[16px] bg-v2-surface-secondary px-5 py-6 shadow-[0px_0px_20px_0px_rgba(0,41,98,0.1)]';

export const HOT_FUTURES_COUNT = 3;
/** A signed-in player has no Trade footer; its room goes to a fourth pair (4 × 48px fills the card). */
export const HOT_FUTURES_MEMBER_COUNT = 4;
export const LEADERBOARD_TOP_COUNT = 3;

/** The board the Leaderboard card opens on (and the server reads); the swap changes only the segment. */
export const LEADERBOARD_BOARD = {
  segment: 'crypto',
  metric: 'volume',
  period: 'month',
  page: 1,
} as const satisfies LeaderboardParams;

/** The two boards the Leaderboard card swaps between. */
export type BoardSegment = Exclude<LeaderboardSegment, 'all'>;

export const OTHER_SEGMENT: Record<BoardSegment, BoardSegment> = {
  prediction: 'crypto',
  crypto: 'prediction',
};

/** Line colours of the 24h sparkline (Figma green/400, red/400). */
export const SPARKLINE_COLOR = { up: '#17d271', down: '#fb4e4b' } as const;
